const $ = require('jquery');
const get = require('lodash/get');
const popup = require('./popup.js');
const modal = require('./modal.js');
require('cropper');

const imgData = {};

module.exports = {
  initCropper(filename) {
    imgData[filename] = {};
    const $cropperImg = $('.thumbCenter > img');
    $cropperImg.cropper('destroy');
    const originalImgHeight = $cropperImg.data('origHeight');
    // augstums preview bildei vienmēr būs 500, skat. thumbCenter.scss
    const imgHeight = $cropperImg.height();
    const imgWidth = $cropperImg.width();
    const rectScale = (imgHeight / originalImgHeight);
    const minCropBoxSize = rectScale * 500;
    // const autoCropArea = $cropperImg.data('admin') ? 1 : 0.8;
    const autoCropArea = 1;

    $cropperImg.cropper({
      aspectRatio: 1 / 1,
      viewMode: 2,
      // minimālais bildes izmērs
      minCropBoxWidth: minCropBoxSize,
      minCropBoxHeight: minCropBoxSize,
      autoCropArea: autoCropArea,
      zoomable: false,
      responsive: false,
      scalable: false,
      restore: true,
      movable: false,
      crop(e) { // Output the result data for cropping image.
        imgData[filename].w = e.width;
        imgData[filename].h = e.height;
        imgData[filename].x = e.x;
        imgData[filename].y = e.y;
        imgData[filename].rotate = e.rotate;
        // Jaunā versija, šobrīd, pieņem tikai pozitīvas vērtības - 90, 180, 270
        if (imgData[filename].rotate < 0) {
          switch (e.rotate) {
            case -90:
              imgData[filename].rotate = 270;
              break;
            case -180:
              imgData[filename].rotate = 180;
              break;
            case -270:
              imgData[filename].rotate = 90;
              break;
            default:
              // Ja ir kāda neatbilstoša negatīva vērtība
              imgData[filename].rotate = 0;
              break;
          }
        }
      },
    });

    const cropper = $cropperImg.data('cropper');

    // Before adding new click listener, remove others. Should be only 1.
    $("[data-method='rotate']").off('click');
    $("[data-method='rotate']").click(function (e) {
      // If not necessary to keep full image in view,
      // this one line is kind of enough
      // cropper.rotate($(this).attr("data-option"));

      const $vex = $('.vex-content');
      const $cropContainer = $('.cropper-container');

      const initialWidth = $cropContainer.width();
      const initialHeight = $cropContainer.height();
      const vexExtraWidth = $vex.width() - initialWidth;

      $vex.width(initialHeight + vexExtraWidth);

      $cropContainer.width(initialHeight);
      $cropContainer.height(initialWidth);

      cropper.rotateKeepFullImageInView($(this).attr("data-option"));
    });

    // Before adding new click listener, remove others. Should be only 1.
    $("[data-generate]").off('click');
    $("[data-generate]").click(function (e) {
      if ($(this).attr('disabled')) {
        return;
      }
      e.preventDefault();
      $(this).attr('disabled', true);
      $(this).addClass('disabled');
      $(this).addClass('has-loader');
      const memberId = $(this).data('memberId');
      const filename = $(this).data('filename');
      const makeProfile = $(this).data('makeProfile');
      const options = {
        custom_crop: {
          // correct scale
          w: imgData[filename].w,
          h: imgData[filename].h,
          x: imgData[filename].x,
          y: imgData[filename].y,
        },
        rotate: imgData[filename].rotate
      };
      const data = {
        member_id: memberId,
        filename,
        options,
        make_profile: makeProfile
      };

      const webroot = get(globals, 'webroot', '/');
      const apiWebroot = get(globals, 'apiWebroot', '/');

      $.post(`${apiWebroot}images/generate`, data, (data) => {
        // Admins centrē bildi no nepārbaudīto bilžu skata
        if (window.location.pathname.indexOf('images/monitor') !== -1
          || window.location.pathname.indexOf('images/fishy') !== -1
          || window.location.pathname.indexOf('images/approve_batch') !== -1
        ) {
          const currentFilename = filename.replace('.jpg', '');
          const newFilename = data.new_filename.replace('.jpg', '');
          const newThumbPath = `/images/get/o-m/${data.new_filename.replace('.jpg', '')}`;
          $(`[src*="${currentFilename}"]`).each(function ($item) {
            const currSrc = $(this).attr('src');
            $(this).attr('src', currSrc.replace(currentFilename, newFilename));
          });
          $(`[href*="${currentFilename}"]`).each(function ($item) {
            const currSrc = $(this).attr('href');
            $(this).attr('href', currSrc.replace(currentFilename, newFilename));
          });
          modal.close();
          // $('[data-file="' + currentFilename + '"] > img').attr('src', newThumbPath);
          // window.location.href = webroot + window.location.pathname;
        }
        // Admins centrē bildi cita lietotāja profilā
        else if (memberId && window.location.pathname.indexOf(memberId) !== -1) {
          window.location.href = `${window.location.origin}${webroot}/member/${memberId}/images`;
        }
        // Lietotājs centrē bildi no sava bilžu skata
        else {
          window.location.href = `${window.location.origin}${webroot}images`;
        }
      });
    });
  },
  init() {
    const _this = this;
    // Before adding new click listener, remove others. Should be only 1.
    $(document).off('click', '.crop-image');
    $(document).on('click', '.crop-image', function (e) {
      e.preventDefault();
      const filename = $(this).data('filename');
      const href = $(this).attr('href');
      popup.thumbCenterPopup(href, () => {
        $(document).off('[data-generate]');
        const $img = $(`img[data-filename="${filename}"]`);
        // lai, events nostrādātu arī cachotām bildēm
        const origSrc = $img.attr('src');
        $img.attr('src', '');
        $img.on('load', () => {
          _this.initCropper(filename);
        }).attr('src', origSrc);
      });
    });

    //
    $(document).ready(function() {
      //
      const url = window.location.href;
      if (!url.includes('thumb_center_href')) {
        return;
      }

      //
      const paramsString = url.split('?')[1];
      let splitParams = [];
      if (paramsString.includes('&')) {
        splitParams = paramsString.split('&');
      } else {
        splitParams.push(paramsString);
      }

      //
      const params = {};
      splitParams.forEach((param) => {
        if (param.includes('=')) {
          const paramParts = param.split('=');
          params[paramParts[0]] = paramParts[1];
        } else {
          params[param] = '';
        }
      });

      //
      if (!params.hasOwnProperty('thumb_center_href')
        || !params.thumb_center_href.length
        || !params.hasOwnProperty('filename')
        || !params.filename.length
      ) {
        return;
      }

      //
      popup.thumbCenterPopup(params.thumb_center_href, function() {
        $(document).off('[data-generate]');
        const $thumbCenterImg = $('img[data-filename="' + params.filename + '"]');
        // lai, events nostrādātu arī cachotām bildēm
        const thumbCenterOrigSrc = $thumbCenterImg.attr('src');
        $thumbCenterImg.attr('src', '');
        $thumbCenterImg.on('load', function() {
          _this.initCropper(params.filename);
        }).attr('src', thumbCenterOrigSrc);
      });
    });
  },
};
